import { IonContent, IonPage, IonGrid, IonRow, IonCol } from '@ionic/react';
import {
    Link
  } from "react-router-dom";
import './Login.css';

const Login: React.FC = () => {
    return (
      <IonPage>
        <IonContent fullscreen>
          <div className='loginContainer'>
            <IonGrid className='loginFormConainer'>
                <IonRow>
                    <IonCol>
                        Login Form here
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <a href="http://softwarestudio.co.uk" target={'_blank'}>&copy; Software Studio</a> | <Link to="/PrivacyPolicy">Privacy Policy</Link>
                    </IonCol>
                </IonRow>
            </IonGrid>
          </div>
        </IonContent>
      </IonPage>
    );
  };
  
  export default Login;